import React from 'react';
import PropTypes from 'prop-types';

/**
 * Reusable Empty State component
 */
const EmptyState = ({ icon = '📋', title, message, action }) => {
  return (
    <div className="empty-state">
      <div className="empty-icon">{icon}</div>
      <div className="empty-title">{title}</div>
      {message && <p>{message}</p>}
      {action && <div style={{ marginTop: '1rem' }}>{action}</div>}
    </div>
  );
};

EmptyState.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  action: PropTypes.node,
};

export default EmptyState;
